const RESOURCES = [
    "Garage",
    "GarageGroup",
    "Garage_Address",
    "Garage_GeoLocation",
    "Garage_SalesCountry",
    "DealerProduct",
    "GarageProduct",
    "ProductCategories",
    "DealerProduct_MassUpdate",
    "DealerProduct_Republish",
    "User",
    "User_Interna",
    "Order",
    "Contract",
    "Coupon",
    "DPA",
    "Customer",
    "Promotion",
    "Dashboard",
    "MailTemplates",
    "MailServer",
    "PriceBook",
    "SupportContext"
] as const;

const ACTIONS = ["list", "create", "write", "delete", "read"] as const;

export type Resource = typeof RESOURCES[number];
export type Action = typeof ACTIONS[number];
export type Permission = `${Resource}_${Action}`;

export const ALL_PERMISSIONS: Permission[] = RESOURCES.flatMap(res =>
    ACTIONS.map(act => `${res}_${act}` as const)
);
